import { useAddressBook } from '@/data/Content/AddressBook';
import { useDeliveryLocationPanel } from '@/data/context/deliveryLocationPanelCtx';
import { Address } from '@/data/types/Address';
import { ADDRESS_BILLING } from '@/utils/address';
import { useRef, useState } from 'react';

export const useDeliveryLocator = () => {
	const { isDeliveryPanelOpen, openDeliveryPanel, closeDeliveryPanel } = useDeliveryLocationPanel();
	const stackRef = useRef<HTMLDivElement>(null);

	const [openGeolocalizationRequestView, setOpenGeolocalizationRequestView] = useState(false);

	const [zipCodeInputValue, setZipCodeInputValue] = useState('');

	const { displayAddresses } = useAddressBook();
	const addressList = displayAddresses.filter(
		(address) => address?.addressType !== ADDRESS_BILLING
	);

	const [isAddAddressOpen, setIsAddAddressOpen] = useState(false);
	const [isEditAddressOpen, setIsEditAddressOpen] = useState(false);
	const [selectedEditAddress, setSelectedEditAddress] = useState(addressList[0]);

	const handleOpenDeliveryPanel = () => {
		openDeliveryPanel();
	};

	const handleCloseDeliveryPanel = () => {
		closeDeliveryPanel();
		setOpenGeolocalizationRequestView(false);
		setZipCodeInputValue('');
		setIsAddAddressOpen(false);
		setIsEditAddressOpen(false);
	};

	const handleOpenAddAddress = () => {
		setIsAddAddressOpen(true);
	};

	const handleCloseAddAddress = () => {
		setIsAddAddressOpen(false);
	};

	const handleOpenEditAddress = (address: Address) => {
		setSelectedEditAddress(address);
		setIsEditAddressOpen(true);
	};

	const handleCloseEditAddress = () => {
		setIsEditAddressOpen(false);
	};

	return {
		addressList,
		handleCloseAddAddress,
		handleCloseDeliveryPanel,
		handleCloseEditAddress,
		handleOpenAddAddress,
		handleOpenDeliveryPanel,
		handleOpenEditAddress,
		isAddAddressOpen,
		isDeliveryPanelOpen,
		isEditAddressOpen,
		openGeolocalizationRequestView,
		selectedEditAddress,
		setOpenGeolocalizationRequestView,
		setZipCodeInputValue,
		stackRef,
		zipCodeInputValue,
	};
};
